import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';

export type OperationalPaymentMethod = 'cash' | 'transfer';

@Component({
  selector: 'foco-payment-method-selector',
  standalone: true,
  imports: [IonIcon],
  template: `
    <div class="payment-methods" role="group" aria-label="Método de pago">
      <button type="button" [class.selected]="method === 'cash'" (click)="select('cash')">
        <ion-icon name="cash-outline"></ion-icon>
        Efectivo
      </button>
      <button type="button" [class.selected]="method === 'transfer'" (click)="select('transfer')">
        <ion-icon name="swap-horizontal-outline"></ion-icon>
        Transferencia
      </button>
    </div>
  `,
  styles: `
    .payment-methods { display: grid; gap: 10px; grid-template-columns: 1fr 1fr; }
    button { align-items: center; background: var(--pos-color-input); border: 2px solid transparent; border-radius: 8px; color: var(--pos-color-text); cursor: pointer; display: grid; font-weight: 800; gap: 8px; min-height: 86px; padding: 12px; place-items: center; }
    button.selected { border-color: var(--pos-color-primary); color: var(--pos-color-primary); }
    ion-icon { font-size: 28px; }
  `,
})
export class PaymentMethodSelectorComponent {
  @Input({ required: true }) method: OperationalPaymentMethod = 'cash';
  @Output() readonly methodChange = new EventEmitter<OperationalPaymentMethod>();

  select(method: OperationalPaymentMethod): void {
    this.methodChange.emit(method);
  }
}
